import { Link } from 'react-router-dom';
import { IconArrowForward } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

const pages = [
  {
    name: 'Generate Leads',
    path: '/leads',
    description: 'Main leads generation page with type management',
    figmaNodeId: '14-33, 60-300, 80-524',
    states: [
      { label: 'Initial (empty)', path: '/leads?state=initial' },
      { label: 'Populated (types list)', path: '/leads?state=populated' },
      { label: 'Selected (type details)', path: '/leads?state=selected' },
    ],
  },
  {
    name: 'Manage Leads',
    path: '/manage-leads',
    description: 'Filter and manage leads with profiles and contacts',
    figmaNodeId: '307-4337',
    states: [{ label: 'Init (no filters)', path: '/manage-leads' }],
  },
  {
    name: 'Login',
    path: '/login',
    description: 'Authentication page with email/OTP and SSO options',
    figmaNodeId: '232-1615, 232-1711',
    states: [
      { label: 'Email entry (init)', path: '/login' },
      { label: 'Google SSO only', path: '/login?mode=google-sso' },
      { label: 'OTP entry', path: '/login?state=otp' },
      { label: 'OTP verifying', path: '/login?state=verifying' },
    ],
  },
  {
    name: 'Demo / Developer Guide',
    path: '/demo',
    description: 'Component library and design system reference',
    figmaNodeId: 'N/A',
    states: [{ label: 'Current page', path: '/demo' }],
  },
];

export const PagesSection = () => (
  <section className={styles.section}>
    <SectionHeader
      title="Pages"
      description="Overview of all pages in the application with their routes and Figma references."
      figmaNodeId={null}
      styles={styles}
    />

    <div className={styles.pagesGrid}>
      {pages.map((page) => (
        <div key={page.path} className={styles.pageCard}>
          <div className={styles.pageCardHeader}>
            <h3 className={styles.pageCardTitle}>{page.name}</h3>
            <Link to={page.path} className={styles.pageCardLink}>
              <IconArrowForward size={18} />
            </Link>
          </div>
          <p className={styles.pageCardDescription}>{page.description}</p>
          <div className={styles.pageCardMeta}>
            <div className={styles.pageCardMetaItem}>
              <span className={styles.pageCardMetaLabel}>Route</span>
              <code className={styles.pageCardMetaValue}>{page.path}</code>
            </div>
            <div className={styles.pageCardMetaItem}>
              <span className={styles.pageCardMetaLabel}>Figma Node ID</span>
              <code className={styles.pageCardMetaValue}>{page.figmaNodeId}</code>
            </div>
          </div>
          <div className={styles.pageCardStates}>
            <span className={styles.pageCardStatesLabel}>States:</span>
            <div className={styles.pageCardStatesList}>
              {page.states.map((state) => (
                <Link key={state.label} to={state.path} className={styles.pageCardStateLink}>
                  {state.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>

    <div className={styles.subsection}>
      <h3 className={styles.subsectionTitle}>Future Pages</h3>
      <p className={styles.hint}>The following pages are planned but not yet implemented:</p>
      <div className={styles.futurePagesGrid}>
        <div className={styles.futurePageCard}>
          <span className={styles.futurePageName}>Overview / Dashboard</span>
          <code className={styles.futurePagePath}>/</code>
        </div>
        <div className={styles.futurePageCard}>
          <span className={styles.futurePageName}>Settings</span>
          <code className={styles.futurePagePath}>/settings</code>
        </div>
      </div>
    </div>
  </section>
);
